import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  pptCount: 0,
  pptLimit: 0,
  isEligibleForDownload:true,
}

export const pptSlice = createSlice({
  name: 'ppt',
  initialState,
  reducers: {
    setPptCount: (state, action) => {
      state.pptCount = action.payload
    },
    setPptLimit: (state, action) => {
      state.pptLimit = action.payload
    },
    setIsEligibleForDownload: (state, action) => {
      state.isEligibleForDownload = action.payload
    },
  },
})

export const { setPptCount, setPptLimit,setIsEligibleForDownload } = pptSlice.actions

// Selectors
export const selectPptCount = (state: any) => state.ppt.pptCount
export const selectPptLimit = (state: any) => state.ppt.pptLimit
export const selectIsEligibleForDownload = (state: any) => state.ppt.isEligibleForDownload

export default pptSlice.reducer